import { Box, Button, Flex, Text } from "@radix-ui/themes";
import { ChatAvatar } from "./ChatAvatar";
import moment from "moment";
import { IChannel } from "./ChannelsList";

export function Channel(props: {
  channel: IChannel;
  currentChannelId: IChannel["id"] | undefined;
  setCurrentChannel: (channel: IChannel | undefined) => void;
}) {
  return (
    <Box key={props.channel.id} py={"2"}>
      <Button
        style={{
          cursor: "pointer",
          backgroundColor:
            props.currentChannelId === props.channel.id
              ? "var(--accent-a3)"
              : undefined,
        }}
        variant={"ghost"}
        color={"gray"}
        asChild
        onClick={() => {
          if (props.currentChannelId === props.channel.id) {
            props.setCurrentChannel(undefined);
          } else {
            props.setCurrentChannel(props.channel);
          }
        }}
      >
        <Flex
          width={"100%"}
          align={"center"}
          justify={"between"}
          style={{ borderBottom: "1px solid var(--gray-6)" }}
        >
          <Flex py={"2"} justify={"start"} width={"100%"} gap={"3"}>
            <Box pl={"1"}>
              <ChatAvatar branding={props.channel.branding} />
            </Box>
            <Box>
              <Text align={"left"} as={"div"}>
                {props.channel.title}
              </Text>
              <Text align={"left"} as={"div"} size={"1"}>
                {props.channel.description}
              </Text>
            </Box>
          </Flex>
          <Box>
            <Text wrap={"nowrap"}>
              {moment(props.channel.timestamp).format("MMM D")}
            </Text>
          </Box>
        </Flex>
      </Button>
    </Box>
  );
}
